import { useMemo } from 'react';

import { getNewUserQuizLocalization } from '../lib/i18n';
import { useNewUserQuizFlow } from '../model/useNewUserQuizFlow';
import { NewUserQuizBooking } from './NewUserQuizBooking';
import { NewUserQuizQuestions } from './NewUserQuizQuestions';

type NewUserQuizProps = {
  email?: string;
  userId: string;
  onBypass: () => void;
  onCompleted: () => void;
  onDismiss: () => void;
};

export const NewUserQuiz = ({ email, userId, onBypass, onCompleted, onDismiss }: NewUserQuizProps) => {
  const flow = useNewUserQuizFlow(userId, onBypass, onCompleted, onDismiss);
  const localization = useMemo(() => getNewUserQuizLocalization(), []);

  if (flow.isBooking) {
    return <NewUserQuizBooking email={email} localization={localization} onDismiss={onDismiss} />;
  }

  return (
    <NewUserQuizQuestions
      answers={flow.answers}
      canContinueAnyway={flow.canContinueAnyway}
      currentStep={flow.currentStep}
      hasSubmitError={flow.hasSubmitError}
      isAdvancing={flow.isAdvancing}
      isSubmitting={flow.isSubmitting}
      localization={localization}
      onBack={flow.goBack}
      onContinueAnyway={flow.continueAnyway}
      onSelectSingle={flow.selectSingleAnswer}
      onSubmit={flow.submit}
      onTogglePriority={flow.togglePriority}
    />
  );
};
